import { Directive, ElementRef, HostListener, inject } from '@angular/core'

function openNativePicker(input: HTMLInputElement): void {
    if (input.disabled) return
    try {
        input.showPicker?.()
    } catch {
        // showPicker() may throw if not user-activated or unsupported; ignore
    }
    input.focus()
}

/**
 * Applies to any <input type="date"> and opens the calendar on pointer interaction.
 * Pair with class `native-datetime-full-picker-hit` on lead custom inputs for consistent
 * right-aligned picker icon styling (see `_form-enhancements.scss`).
 */
@Directive({
    selector: 'input[type="date"]',
    standalone: true,
})
export class AutoOpenDatePickerDirective {
    private readonly el = inject(ElementRef<HTMLInputElement>)

    @HostListener('pointerdown', ['$event'])
    onPointerDown(event: PointerEvent): void {
        if (event.pointerType === 'mouse' && event.button !== 0) return
        openNativePicker(this.el.nativeElement)
    }
}

/**
 * Same UX as {@link AutoOpenDatePickerDirective} for <input type="time">.
 */
@Directive({
    selector: 'input[type="time"]',
    standalone: true,
})
export class AutoOpenTimePickerDirective {
    private readonly el = inject(ElementRef<HTMLInputElement>)

    @HostListener('pointerdown', ['$event'])
    onPointerDown(event: PointerEvent): void {
        if (event.pointerType === 'mouse' && event.button !== 0) return
        openNativePicker(this.el.nativeElement)
    }
}
